import { render } from "./CourseRating.vue?vue&type=template&id=49014a2f&scoped=true"
import script from "./CourseRating.vue?vue&type=script&lang=js"
export * from "./CourseRating.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./CourseRating.vue?vue&type=style&index=1&id=49014a2f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49014a2f"]])

export default __exports__